export default __webpack_public_path__ + "static/media/009-packages-2.f9aea1cf.png";